import { array } from '../../utils/array';
import { Uuid } from '../../models/Base';
import { Post } from '../../models/PostStore/Post';
import { PostStoreState } from '../../models/PostStore/PostStore';
import { Cursor } from '../../models/Repository';
import { NonEmptyArray } from '../../models/Utils';

export const getPost = (state: PostStoreState, postId: Uuid) =>
  state.posts.get(postId);

export const getPosts = (state: PostStoreState, fieldName: string) =>
  state.posts.list(fieldName, null)?.get() ?? [];

export const setPosts = (
  state: PostStoreState,
  fieldNames: string | string[],
  ...posts: Post[]
) => {
  state.posts.lists(array(fieldNames) as NonEmptyArray<string>).set(...posts);
};

export const pushPosts = (
  state: PostStoreState,
  fieldNames: string | string[],
  ...posts: Post[]
) => {
  state.posts.lists(array(fieldNames) as NonEmptyArray<string>).push(...posts);
};

export const setPostCursor = (
  state: PostStoreState,
  fieldNames: string | string[],
  cursor: Cursor,
) => {
  state.posts
    .lists(array(fieldNames) as NonEmptyArray<string>)
    .setCursor(cursor);
};
